export const ColorCMM = () => { return "#93C4D7"}
export const ColorGSM = () => { return "#9AD7A5"}
export const ColorNGR = () => { return "#EADA9A"}
export const ColorNGV = () => { return "#C5CB68"}
